import { RenderDropdownBodyProps } from './FilterDropdown.model';
import { Button, DropdownContainer, FlexRow, Panel } from '@epam/uui';
import FilterOption from './FilterOption';
import React from 'react';

const renderBody = <TFilter = Record<string, string[]>,>(
  props: RenderDropdownBodyProps<TFilter>,
) => {
  return (
    <DropdownContainer {...props} maxWidth={420} showArrow={true}>
      <Panel background="surface-main">
        {Object.values(props.settings).map((setting) => (
          <FilterOption
            key={setting.key}
            setting={setting}
            value={props.filter[setting.key as keyof TFilter] as string[]}
            onValueChange={(v) =>
              props.updateFilter({ [setting.key]: v } as Partial<TFilter>)
            }
          />
        ))}

        <FlexRow columnGap="12" padding="18" vPadding="24">
          <Button
            caption="Apply"
            color="primary"
            onClick={() => {
              props.applyFilter();
              props.onClose?.();
            }}
          />
          <Button
            caption="Close"
            color="secondary"
            fill="outline"
            onClick={() => {
              props.resetFilter();
              props.onClose?.();
            }}
          />
        </FlexRow>
      </Panel>
    </DropdownContainer>
  );
};

export default renderBody;
